<template>
<div class="ti">
  <div style="margin-top: 5px;margin-left: 5px;">
    <div>
      <el-button size="mini" type="primary text2"  @click="modals" v-if="ERP.isPermission(2001001)">添加项目</el-button>
      <router-link to="/Project/Split">
        <el-button size="mini" type="primary text2" v-if="ERP.isPermission(2001001)">项目拆分</el-button>
      </router-link>
      <el-select size="mini" v-model="value" filterable placeholder="请选择战区" class="kuan">
        <el-option
          key=""
          label="全部"
          value="">
        </el-option>
        <el-option
          v-for="item in zoneList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
      <el-button size="mini" type="primary text2" @click="searchs(1)">搜索</el-button>
    </div>
    <div class="text6">项目新建绑定导入房产和生成订单后，不可删除项目，删除项目将可能导致绑定该项目的房产和订单不显示，只可修改，删除需联系运维人员</div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <th class="text-left">项目名称</th>
              <th class="text-left">项目备注</th>
              <th class="text-left">日期</th>
              <th class="text-left">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text1" v-for="item in desserts" :key="item.id">
              <td >{{item.id}}</td>
              <td >{{item.name}}</td>
              <td ><div v-if="item.jremarks">{{item.jremarks}}</div><div v-else>--</div></td>
              <td >{{item.date}}</td>
              <td class="cdj_td">
                <div v-if="ERP.isPermission(2001014)">
                  <div style="color: #1867c0;margin-left: 5px;cursor: pointer;" @click="xiugai( item.id )">修改</div>
                </div>
                <div v-if="ERP.isPermission(2001015)">
                  <div style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )">删除</div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
  </div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="项目名称">
              <el-input v-model="dades.name"></el-input>
            </el-form-item>
            <el-form-item label="项目编号">
              <el-input v-model="dades.number"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="opdadeval[1].valid" placeholder="请选择" v-if="opdade[1][0]['id']" @change="changes(opdadeval[1].valid,1)">
                <el-option
                  v-for="item in opdade[1]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[2].valid"  placeholder="请选择" v-if="opdade[2][0]['id']" @change="changes(opdadeval[2].valid,2)">
                <el-option
                  v-for="item in opdade[2]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[3].valid" style="margin-top: 3.6px;" placeholder="请选择" v-if="opdade[3][0]['id']" @change="changes(opdadeval[3].valid,3)">
                <el-option
                  v-for="item in opdade[3]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[4].valid"  placeholder="请选择" v-if="opdade[4][0]['id']" @change="changes(opdadeval[4].valid,4)">
                <el-option
                  v-for="item in opdade[4]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[5].valid" placeholder="请选择" v-if="opdade[5][0]['id']" @change="changes(opdadeval[5].valid,5)">
                <el-option
                  v-for="item in opdade[5]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="缴费方式">
                <el-select v-model="dades.class2" placeholder="请选择缴费方式" style="width: 100%;">
                <el-option label="月缴" value="1"></el-option>
                <el-option label="季度缴" value="2"></el-option>
                <el-option label="半年缴" value="3"></el-option>
                <el-option label="年缴" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="后台缴费">
                <el-select v-model="dades.jump" placeholder="请选缴费方式" style="width: 100%;">
                <el-option label="可跳着缴款" value="2"></el-option>
                <el-option label="不可跳着缴款" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="可跳收项">
              <el-select v-model="dades.not_chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="后台缴款,可跳收项目">
                  <el-option
                    v-for="item in chargeitem_list"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公众号">
                <el-select v-model="dades.class1" placeholder="请选择缴费顺序">
                <el-option label="按月缴（按照顺序缴费）" value="1"></el-option>
                <el-option label="跳着缴（可以不按顺序缴费）" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="自动折扣">
                <el-select v-model="dades.discount_type" placeholder="自动折扣" style="width: 100%;">
                  <el-option label="关闭" value="0"></el-option>
                  <el-option label="开启" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账龄费项">
              <div v-if="ERP.isPermission(20010017)">
                <el-select v-model="dades.chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="账龄费项">
                    <el-option
                      v-for="item in chargeitem_list"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                </el-select>
              </div>
              <div v-else>
                <el-select :disabled="true" v-model="dades.chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="账龄费项">
                    <el-option
                      v-for="item in chargeitem_list"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                </el-select>
              </div>

            </el-form-item>
            <el-form-item label="能耗账龄费项">
              <div v-if="ERP.isPermission(20010017)">
                <el-select v-model="dades.meter_chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="能耗账龄费项">
                  <el-option
                    v-for="item in meter_chargeitem_list"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div v-else>
                <el-select :disabled="true" v-model="dades.meter_chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="能耗账龄费项">
                  <el-option
                    v-for="item in meter_chargeitem_list"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="能耗绩效费项">
                <el-select :disabled="!ERP.isPermission(20010017)" v-model="dades.meter_performance_chargeitem_id" style="width: 100%;" multiple clearable filterable allow-create default-first-option placeholder="能耗账龄费项">
                  <el-option
                    v-for="item in meter_chargeitem_list"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="项目备注">
              <el-input v-model="dades.jremarks"></el-input>
            </el-form-item>
            <el-form-item label="项目类型">
                <el-select v-model="dades.type" style="width: 100%;">
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="外拓" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="能耗类型">
              <el-select v-model="dades.meter_model" style="width: 100%;" placeholder="能耗类型">
                <el-option
                  v-for="item in meter_model_options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="缴费最低比例">
              <el-input-number :min="0" :max="100" :step="1" v-model="dades.mini_proportion"></el-input-number>%
            </el-form-item>
            <el-form-item label="归属部门">
              <el-cascader
                style="width: 100%;"
                v-model="dades.department_id"
                placeholder="请选择"
                :options="departmentList"
                :props="{ checkStrictly: true, label:'department_name', value:'id', children:'children' }"
                filterable></el-cascader>
            </el-form-item>
            <el-form-item label="归属劳务公司">
              <el-cascader style="width: 100%;"
                           v-model="dades.work_company_id"
                           placeholder="请选择"
                           :options="workCompanyList"
                           :props="{ checkStrictly: true, label:'WorkCompanyName', value:'ID', children:'children' }"
                           filterable>
              </el-cascader>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
import Http from "../Oa/common/Http";
export default {
  name: "projectIndex",
  data() {
    return {
      chargeitem_list: [],
      meter_chargeitem_list: [],
      pages: "",
      defaultcheckedkeys: [],
      defaultcheckedkeyssa: [],
      opdadeval: [
        {
          valid: "",
        },
        {
          valid: "",
        },
        {
          valid: "",
        },
        {
          valid: "",
        },
        {
          valid: "",
        },
        {
          valid: "",
        },
      ],
      opdade: [
        [
          {
            id: 0,
            jname: "0",
          },
        ],
        [
          {
            id: 0,
            jname: "0",
          },
        ],
        [
          {
            id: 0,
            jname: "0",
          },
        ],
        [
          {
            id: 0,
            jname: "0",
          },
        ],
        [
          {
            id: 0,
            jname: "0",
          },
        ],
        [
          {
            id: 0,
            jname: "0",
          },
        ],
      ],
      dades: {
        id: "",
        distinguish: "0",
        login_name: "",
        name: "",
        company_id: "",
        company_id1: "",
        jremarks: "",
        class2: "",
        jump: "",
        chargeitem_id: "",
        meter_chargeitem_id: "",
        meter_performance_chargeitem_id: "",
        class1: "",
        not_chargeitem_id:"",
        discount_type:'0',
        type: "0",
        meter_model: 1,
        mini_proportion: 95,
        department_id:0 ,
        work_company_id : 0 , //归属劳务公司
      },
      options: [
        {
          value: "",
          label: "",
        },
      ],
      options1: [
        {
          value: "",
          label: "",
        },
      ],
      options2: [],
      meter_model_options: [
        {
          id: 0,
          label: "其他",
        },{
          id: 1,
          label: "分摊制",
        },{
          id: 2,
          label: "包干制",
        },{
          id: 3,
          label: "固定制",
        },
      ],
      value: "",
      value1: "",
      input1: "",
      desserts: "",
      cs: "",
      total: 0,
      page: 12,
      search: "",
      anxiu: "保存",
      modal1: false,
      zoneList: [],
      departmentList: [],
      workCompanyList : [],
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    var t = Date.parse(new Date()) / 1000; //时间戳
    var login = window.localStorage.getItem("login");
    ERP.showLoading();
    this.$Loading.start();
    this.$myhttp
      .get("admin/getcompanygshu?login=" + login, {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp
          .get(
            "admin/project?id=1" +
              "&company=" +
              this.value +
              "&company1=" +
              this.value1 +
              "&t=" +
              t +
              "&distinguish=0",
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
            ERP.hideLoading();
          });
      });
    //加载公司列表和归属列表
    this.$myhttp
      .get("admin/getcompany", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
      });

    //https://api.oa.gdzawy.com:9001/admin/common/chargritem?datest=1705303535&login_name=%E8%AE%B8%E5%A4%A7%E5%BE%97&token=asd26459bc4b4d820949a957f23016b213bd846dade&oa_user_id=6141
    this.$myhttp
      .post(
        "admin/common/chargritem",
        {},
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      )
      .then((backdata) => {
        // 异步执行成功后
        if (backdata.data.code == 200) {
          // console.log(backdata.data.data)
          this.chargeitem_list = backdata.data.data;
        }
      });
    this.$myhttp
      .post(
        "admin/common/meter_chargritem",
        {},
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      )
      .then((backdata) => {
        // 异步执行成功后
        if (backdata.data.code == 200) {
          // console.log(backdata.data.data)
          this.meter_chargeitem_list = backdata.data.data;
        }
      });
    this.getZoneList();
    this.getDepartmentList();
    this.getWorkCompanyList();
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    // 获取自己名下的战区
    getZoneList() {
      this.$myhttp
        .post(
          "admin/common/zones",
          {},
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.zoneList = backdata.data.data;
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    //折扣,减免
    discount(e, e1, e2, e3) {
      this.$router.push({
        path: "/pindex/discounts",
        query: { id: e, company_name: e1, jname: e2, name: e3 },
      });
    },
    //跳转
    allocation(e, e1, e2, e3) {
      this.$router.push({
        path: "/pindex/Allocation",
        query: { id: e, company_name: e1, jname: e2, name: e3 },
      });
    },
    allocations(e, e1, e2, e3) {
      this.$router.push({
        path: "/pindex/Allocations",
        query: { id: e, company_name: e1, jname: e2, name: e3 },
      });
    },
    //根据组织查归属
    changesa(e) {
      // console.log(e);
      this.$myhttp
        .get("admin/getJlistOps?id=" + e, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.opdade[0] = backdata.data[0];
          var bc = backdata.data[0];
          this.$forceUpdate();
          this.$myhttp
            .get("admin/sxjm", {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              // 异步执行成功后
              this.opdade[0] = bc;
              this.opdadeval[0].valid = "";
              this.opdade[1] = [{ id: "", jname: "" }];
              this.opdade[2] = [{ id: "", jname: "" }];
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            });
        });
    },
    //监听选择归属改变
    changes(e, op) {
      // console.log(e);//id
      // console.log(op);//属于哪一个数组
      var ops = op + 1;
      // console.log(ops);
      this.$myhttp
        .get("admin/getJlistOp?id=" + e, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data[1] == 200) {
            this.opdadeval[ops]["valid"] = "";
            if (ops == 1) {
              this.opdade[1] = [{ id: "", jname: "" }];
              this.opdade[2] = [{ id: "", jname: "" }];
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 2) {
              this.opdade[2] = [{ id: "", jname: "" }];
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 3) {
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 4) {
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 5) {
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            this.opdade[ops] = backdata.data[0];
          } else {
            this.opdadeval[ops]["valid"] = "";
            if (ops == 1) {
              this.opdade[1] = [{ id: "", jname: "" }];
              this.opdade[2] = [{ id: "", jname: "" }];
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 2) {
              this.opdade[2] = [{ id: "", jname: "" }];
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 3) {
              this.opdade[3] = [{ id: "", jname: "" }];
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 4) {
              this.opdade[4] = [{ id: "", jname: "" }];
              this.opdade[5] = [{ id: "", jname: "" }];
            }
            if (ops == 5) {
              this.opdade[5] = [{ id: "", jname: "" }];
            }
          }
          //  console.log(this.opdadeval);
          this.$forceUpdate();
        });
    },
    //保存
    ok() {
      if (this.dades.jname == "") {
        this.$Message.error("架构名称不能为空!");
        return false;
      }
      // if(this.opdadeval[0].valid == ''){
      //   this.$Message.error('项目归属不能为空不能为空!');
      //   return false;
      // }
      if (this.dades.class2 == "" || this.dades.class2 == null) {
        this.$Message.error("请选择缴费方式!");
        return false;
      }
      if (this.dades.class1 == "" || this.dades.class1 == null) {
        this.$Message.error("请选择缴费顺序!");
        return false;
      }
      if (this.anxiu == "保存") {
        this.pages = 1;
      }
      var login = window.localStorage.getItem("login");
      this.dades.login_name = login;
      var date = [this.dades, this.opdadeval, this.opdade];
      this.$myhttp
        .post("admin/projectAdd", date, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data["code"] == 203) {
            this.$Message.error(
              "添加失败，允许新建项目数：" + backdata.data["number"]
            );
            return false;
          }
          if (backdata.data["code"] == 205) {
            this.$Message.error("编辑失败：" + backdata.data["number"]);
            return false;
          }
          if (backdata.data[0] == 1) {
            this.$Message.success(backdata.data[1]);
            this.dades = {
              id: "",
              distinguish: "0",
              login_name: "",
              name: "",
              company_id: "",
              company_id1: "",
              jremarks: "",
              class2: "",
              class1: "",
              discount_type:'0',
              type: "0",
              meter_model: 1,
              mini_proportion: 95,
              department_id: 0
            };
          } else {
            this.$Message.error("编辑失败!");
          }
          this.searchs(this.pages);
        });
    },
    //弹窗添加
    modals() {
      this.anxiu = "保存";
      if (this.dades.id) {
        this.dades = {
          id: "",
          distinguish: "0",
          login_name: "",
          name: "",
          company_id: "",
          company_id1: "",
          jremarks: "",
          class2: "",
          class1: "",
          meter_model:1,
          mini_proportion:95,
          department_id: 0
        };
        this.opdade[1] = [{ id: "", jname: "" }];
        this.opdade[2] = [{ id: "", jname: "" }];
        this.opdade[3] = [{ id: "", jname: "" }];
        this.opdade[4] = [{ id: "", jname: "" }];
        this.opdade[5] = [{ id: "", jname: "" }];
        this.opdadeval[0]["valid"] = "";
      }
      //console.log('dades',this.dades)
      //加载公司权限列表
      var login = window.localStorage.getItem("login");
      this.$myhttp
        .get("admin/getJlist?login=" + login, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data[1] == 2) {
            this.data = backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id = backdata.data[3];
          // this.opdade[0] = backdata.data[4];
        });
      this.$myhttp
        .get("admin/getJlistssa?login=" + login, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.opdade[0] = backdata.data[0];
          this.modal1 = true;
        });
    },
    //获得当前多少页,分页
    change(e) {
      this.pages = e;
      ERP.showLoading();
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000; //时间戳
      this.$myhttp
        .get(
          "admin/project?id=" +
            e +
            "&search=" +
            this.search +
            "&company=" +
            this.value +
            "&company1=" +
            this.value1 +
            "&t=" +
            t +
            "&distinguish=0",
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          ERP.hideLoading();
        });
    },
    //搜索
    searchs(e) {
      this.pages = e;
      ERP.showLoading();
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000; //时间戳
      this.$myhttp
        .get(
          "admin/project?search=" +
            this.search +
            "&id="+this.pages +
            "&company=" +
            this.value +
            "&company1=" +
            this.value1 +
            "&t=" +
            t +
            "&distinguish=0",
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          ERP.hideLoading();
        });
    },
    //修改查询
    xiugai(e) {
      this.anxiu = "修改";
      this.$myhttp
        .get("admin/getProjectUpdate?id=" + e, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.dades = backdata.data[0][0];
          this.cs = backdata.data[3];

          this.opdadeval[0].valid = backdata.data[1];
          this.opdade[0] = backdata.data[2];
          this.opdade[1] = [{ id: "", jname: "" }];
          this.opdade[2] = [{ id: "", jname: "" }];
          this.opdade[3] = [{ id: "", jname: "" }];
          this.opdade[4] = [{ id: "", jname: "" }];
          this.opdade[5] = [{ id: "", jname: "" }];

          // this.opdadeval = backdata.data[1];
          // this.opdade = backdata.data[2];

          this.$forceUpdate();
          this.modal1 = true;
        });
    },
    //删除
    del(e) {
      this.$confirm("此操作将永久删除该权限吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$myhttp
            .post(
              "admin/projectDelete",
              { id: e },
              {
                "Content-Type": "application/x-www-form-urlencoded",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data == 200) {
                this.dela = true;
                var t = Date.parse(new Date()) / 1000; //时间戳
                this.$myhttp
                  .get(
                    "admin/project?id=1" +
                      "&company=" +
                      this.value +
                      "&company1=" +
                      this.value1 +
                      "&t=" +
                      t +
                      "&distinguish=0",
                    {
                      "Content-Type": "application/json",
                    }
                  )
                  .then((backdata) => {
                    // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Message.success("删除成功!");
                  });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取部门列表
    getDepartmentList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/Department/listAll", {}, res => {
        if (res.code == 0) {
          that.departmentList = res.data
        } else {
          that.departmentList = []
        }
      })
    },
    // 获取劳务公司列表
    getWorkCompanyList(){
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/HrLegalUnit/getAllCompanyList", {}, res => {
        if (res.code == 0) {
          that.workCompanyList = res.data
        } else {
          that.workCompanyList = []
        }
      })
    },
  },
};
</script>
<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.texts {
  margin-left: 10.6%;
  color: brown;
}
.text6 {
  color: brown;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/index.vue